import { useState } from "react";
import { Loader2, BellRing } from "lucide-react";
import { Input } from "@/components/ui/input";
import { http, errorMessage } from "@/lib/api";

export const WaitlistForm = ({ postcode }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ loading: false, done: "", error: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
      setState({ loading: false, done: "", error: "Please enter a valid email address." });
      return;
    }
    setState({ loading: true, done: "", error: "" });
    try {
      const { data } = await http.post("/waitlist", { email, postcode });
      setState({ loading: false, done: data.message, error: "" });
    } catch (err) {
      setState({ loading: false, done: "", error: errorMessage(err) });
    }
  };

  if (state.done)
    return (
      <p className="mt-4 flex items-center gap-2 rounded-xl bg-[#D4A437]/10 p-3 text-sm text-[#F3E0A2]" data-testid="waitlist-success">
        <BellRing className="h-4 w-4" /> {state.done}
      </p>
    );

  return (
    <form onSubmit={submit} noValidate className="mt-4 flex flex-col gap-2 sm:flex-row sm:flex-wrap" data-testid="waitlist-form">
      <label htmlFor="waitlist-email" className="sr-only">Email address</label>
      <Input id="waitlist-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
        autoComplete="email" aria-invalid={!!state.error} className="lc-input flex-1" data-testid="waitlist-email-input" />
      <button type="submit" disabled={state.loading} className="lc-btn-ghost !py-3" data-testid="waitlist-submit">
        {state.loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Join waiting list"}
      </button>
      {state.error && <p className="text-sm text-[#ff8a3d] sm:basis-full" role="alert" data-testid="waitlist-error">{state.error}</p>}
    </form>
  );
};
